import React from "react";
import { useSearchParams, Link } from "react-router-dom";

export default function PaymentFailed() {
  const [params] = useSearchParams();
  const orderId  = params.get("order"); // kept for future use / display

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400&family=DM+Sans:wght@300;400;500&display=swap');
        .pf-root*,.pf-root *::before,.pf-root *::after{box-sizing:border-box;margin:0;padding:0}
        .pf-root{font-family:'DM Sans',sans-serif;background:#fdf9f6;min-height:80vh;display:flex;align-items:center;justify-content:center;padding:40px 20px}
        .pf-card{background:#fff;border:1px solid #ede8e2;padding:52px 48px;max-width:520px;width:100%;text-align:center}
        @media(max-width:480px){.pf-card{padding:36px 24px}}
        .pf-icon{width:64px;height:64px;background:#fff5f5;border:2px solid #ffd6d6;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 24px}
        .pf-title{font-family:'Cormorant Garamond',serif;font-size:36px;font-weight:300;color:#1a1410;margin-bottom:10px;display:block}
        .pf-sub{font-size:14px;font-weight:300;color:#7a6e68;line-height:1.7;margin-bottom:28px;display:block}
        .pf-ref{background:#f7f4f1;padding:12px;margin-bottom:24px;font-size:12px;color:#a09890}
        .pf-actions{display:flex;gap:12px;justify-content:center;flex-wrap:wrap}
        .pf-btn{display:inline-block;padding:12px 24px;font-size:11px;font-weight:500;font-family:'DM Sans',sans-serif;letter-spacing:.18em;text-transform:uppercase;text-decoration:none;transition:all .2s}
        .pf-btn-primary{background:#1a1410;color:#fdf9f6}
        .pf-btn-primary:hover{background:#c87090}
        .pf-btn-outline{border:1.5px solid #ddd8d2;color:#5a524c}
        .pf-btn-outline:hover{border-color:#1a1410;color:#1a1410}
      `}</style>

      <div className="pf-root">
        <div className="pf-card">

          <div className="pf-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e87070" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
          </div>

          <span className="pf-title">Payment Failed</span>
          <span className="pf-sub">
            Your payment was not completed and your order has not been placed.
            Please try again or contact us on WhatsApp if the issue continues.
          </span>

          {orderId && (
            <div className="pf-ref">Reference: {orderId}</div>
          )}

          <div className="pf-actions">
            <Link to="/checkout" className="pf-btn pf-btn-primary">Try Again</Link>
            <Link to="/contact"  className="pf-btn pf-btn-outline">Contact Support</Link>
          </div>

        </div>
      </div>
    </>
  );
}